module.exports = __webpack_public_path__ + "img/default.92cb0168.png";